<template><Catalog viewer="school" /></template>

<script>
import Catalog from '../Student/Catalog';

export default {
  name: 'SchoolCourseList',
  components: { Catalog }
};
</script>
